export default [
    {
        path: 'solicitacao',
        component: () => import(
            /* webpackChunkName: 'regulacao-solicitacao' */
            '@/views/regulacao/solicitacao/Index'
        ),
        redirect: 'solicitacao/index',
        children: [
            {
                name: 'regulacao-solicitacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'regulacao-solicitacao' */
                    '@/views/regulacao/solicitacao/List.vue'
                ),
            },
            {
                name: 'regulacao-solicitacao-create',
                path: 'create/:pacienteId',
                props: route => ({ pacienteId: parseInt(route.params.pacienteId) }),
                component: () => import(
                    /* webpackChunkName: 'regulacao-solicitacao' */
                    '@/views/regulacao/solicitacao/Form.vue'
                ),
            },
            {
                name: 'regulacao-solicitacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id), pacienteId: parseInt(route.params.pacienteId) }),
                component: () => import(
                    /* webpackChunkName: 'regulacao-solicitacao' */
                    '@/views/regulacao/solicitacao/Form.vue'
                ),
            },
        ],
    },
]